"use strict";

$(document).ready(function(){
	// mobile nav
    $('.header__nav--mobile').click(function(){
        $('.hamburger').toggleClass('is-active');
        if($('.hamburger').hasClass('is-active')){
			// $('body').css({'position' : 'fixed'});
			$('.header__nav').css({'display' : 'flex'});
			$('.header__nav--wrap').addClass('is-active');
        } else{
			// $('body').css({'position' : 'relative'});
			$('.header__nav').css({'display' : 'none'});
			$('.header__nav--wrap').removeClass('is-active');
        }
    });

	// mission meter
	if(window.location.pathname == '/'){
		var element = document.getElementById('meter');
		var elementHeight = element.clientHeight;

		// listen for scroll event and call animate function
		document.addEventListener('scroll', animate);

		// check if element is in view
		function inView(){
			var windowHeight = window.innerHeight;
			var scrollY = window.scrollY || window.pageYOffset;
		
			var scrollPosition = scrollY + windowHeight;
			var elementPosition = element.getBoundingClientRect().top + scrollY + elementHeight;
		
		// is scroll position greater than element position? (is element in view?)
			if(scrollPosition > elementPosition){
				return true;
			}		
			return false;
		}

		// animate element when it is in view
		function animate(){
			if (inView()){
				element.classList.add('animate');
			}
		}
	}
	
	// media filter
	$('[name="filter"]').change(function(){
		var url = $(this).val();
		window.location.href = url;
	});
	
	// lity
	$('.wp-block-image img').attr('data-lity', '');
	$('.wp-block-timeline img').attr('data-lity', '');

	// aos
	AOS.init({
		easing: 'ease',
		duration: 1500
	});

	// anchors
	$(function(){
		$('a[href*="#"]:not([href="#"])').click(function(){
			if(location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname){
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				if(target.length){
					$('html, body').animate({
						scrollTop: target.offset().top - 100
					}, 1000);
					return false;
				}
			}
		});
	});
});